// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__VXNee","rotation":"spinner_rotation__yVZ37"};